export class RiskAssessmentHelper {
  public static get ALGO_ETS(): string {
    return "ETS";
  }
  public static get ALGO_GBTP(): string {
    return "GBTP";
  }
}
